import { Injectable } from '@angular/core';
import { EShoppingCartItemValidationError, EShoppingCartValidationError } from '../INTEGRA_Shop_Client';

@Injectable({
  providedIn: 'root'
})
export class CartValidationHelperService {

  public static shoppingCartValidationErrorExplanationGet(eShoppingCartValidationError: EShoppingCartValidationError) {
    let errorExplanationMessage: string;
    switch (eShoppingCartValidationError) {
      case EShoppingCartValidationError.CartNotFound:
        errorExplanationMessage = $localize`:@@CartValidationErrorCartNotFoundExplanationMessage:The requested cart could not be found.`;
        break;

      case EShoppingCartValidationError.DeliveryAddressIsInvalid:
        errorExplanationMessage = $localize`:@@CartValidationErrorDeliveryAddressIsInvalidExplanationMessage:The delivery address is invalid.`;
        break;

      case EShoppingCartValidationError.DeliveryDateIsInvalid:
        errorExplanationMessage = $localize`:@@CartValidationErrorDeliveryDateIsInvalidExplanationMessage:The delivery date is invalid.`;
        break;

      case EShoppingCartValidationError.Unauthorized:
        errorExplanationMessage = $localize`:@@CartValidationErrorUnauthorizedExplanationMessage:Authorization missing.`;
        break;

      default:
        throw new Error(`Missing implementation for ${EShoppingCartValidationError[eShoppingCartValidationError]} in CartValidationHelperService.`);
    }

    return errorExplanationMessage;
  }

  public static shoppingCartValidationErrorSolutionGet(eShoppingCartValidationError: EShoppingCartValidationError) {
    let errorSolutionMessage: string;
    switch (eShoppingCartValidationError) {
      case EShoppingCartValidationError.CartNotFound:
        errorSolutionMessage = $localize`:@@CartValidationErrorCartNotFoundSolutionMessage:Please create a new cart.`;
        break;

      case EShoppingCartValidationError.DeliveryAddressIsInvalid:
        errorSolutionMessage = $localize`:@@CartValidationErrorDeliveryAddressIsInvalidSolutionMessage:Please edit your cart and select another address.`;
        break;

      case EShoppingCartValidationError.DeliveryDateIsInvalid:
        errorSolutionMessage = $localize`:@@CartValidationErrorDeliveryDateIsInvalidSolutionMessage:Please select a new date for the delivery.`;
        break;

      case EShoppingCartValidationError.Unauthorized:
        errorSolutionMessage = $localize`:@@CartValidationErrorUnauthorizedSolutionMessage:Please contact us if this feature is needed.`;
        break;

      default:
        throw new Error(`Missing implementation for ${EShoppingCartValidationError[eShoppingCartValidationError]} in CartValidationHelperService.`);
    }

    return errorSolutionMessage;
  }



  public static shoppingCartItemValidationErrorExplanationGet(eShoppingCartItemValidationError: EShoppingCartItemValidationError) {
    let errorExplanationMessage: string;
    switch (eShoppingCartItemValidationError) {
      case EShoppingCartItemValidationError.DuplicateProductIdentifier:
        errorExplanationMessage = $localize`:@@CartItemValidationErrorDuplicateProductIdentifierExplanationMessage:This product is already in your cart.`;
        break;

      case EShoppingCartItemValidationError.ProductHasExportBan:
        errorExplanationMessage = $localize`:@@CartItemValidationErrorDeliveryProductHasExportBanExplanationMessage:This product may not be exported.`;
        break;

      case EShoppingCartItemValidationError.ProductIsInactive:
        errorExplanationMessage = $localize`:@@CartItemValidationErrorDeliveryProductIsInactiveExplanationMessage:This product is no longer up for order.`;
        break;

      case EShoppingCartItemValidationError.ProductIsOutOfStock:
        errorExplanationMessage = $localize`:@@CartItemValidationErrorProductIsOutOfStockExplanationMessage:The requested amount is to high.`;
        break;

      case EShoppingCartItemValidationError.Unauthorized:
        errorExplanationMessage = $localize`:@@CartItemValidationErrorUnauthorizedExplanationMessage:Authorization missing.`;
        break;

      default:
        throw new Error(`Missing implementation for ${EShoppingCartItemValidationError[eShoppingCartItemValidationError]} in CartValidationHelperService.`);
    }

    return errorExplanationMessage;
  }

  public static shoppingCartItemValidationErrorSolutionGet(eShoppingCartItemValidationError: EShoppingCartItemValidationError) {
    let errorSolutionMessage: string;
    switch (eShoppingCartItemValidationError) {
      case EShoppingCartItemValidationError.DuplicateProductIdentifier:
        errorSolutionMessage = $localize`:@@CartItemValidationErrorDuplicateProductIdentifierSolutionMessage:Please remove the other product.`;
        break;

      case EShoppingCartItemValidationError.ProductHasExportBan:
        errorSolutionMessage = $localize`:@@CartItemValidationErrorDeliveryProductHasExportBanSolutionMessage:Please select a different delivery address.`;
        break;

      case EShoppingCartItemValidationError.ProductIsInactive:
        errorSolutionMessage = $localize`:@@CartItemValidationErrorDeliveryProductIsInactiveSolutionMessage:Please select an alternative product.`;
        break;

      case EShoppingCartItemValidationError.ProductIsOutOfStock:
        errorSolutionMessage = $localize`:@@CartItemValidationErrorProductIsOutOfStockSolutionMessage:`;
        break;

      case EShoppingCartItemValidationError.Unauthorized:
        errorSolutionMessage = $localize`:@@CartItemValidationErrorUnauthorizedSolutionMessage:Please contact us if this feature is needed.`;
        break;

      default:
        throw new Error(`Missing implementation for ${EShoppingCartItemValidationError[eShoppingCartItemValidationError]} in CartValidationHelperService`);
    }

    return errorSolutionMessage;
  }

}
